import { debugNd68 } from "./debugNd68"

const debug = async () => {
    //debugNa87()
    // setKeys()
    //console.clear()
    //debugMU68()
    debugNd68()
}



export const setDebug = () => {
    (window as any).debug = debug
}
